function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 12.321,
    viewBox: "0 0 21 12.321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.989 10V5.941a1.517 1.517 0 0 1-.766.878L2.02 11.05a1.629 1.629 0 0 1-.878.274A1.178 1.178 0 0 1 0 10V1.331A1.178 1.178 0 0 1 1.141 0a1.63 1.63 0 0 1 .879.277l7.2 4.23a1.5 1.5 0 0 1 .766.865V1.331A1.173 1.173 0 0 1 11.12 0a1.674 1.674 0 0 1 .886.275l7.2 4.23A1.319 1.319 0 0 1 20 5.66a1.34 1.34 0 0 1-.794 1.159l-7.2 4.231a1.649 1.649 0 0 1-.878.274A1.178 1.178 0 0 1 9.989 10z",
    transform: "translate(.497 .497)",
    style: {
      fill: "currentColor"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.c3401eb6.svg";
export { ForwardRef as ReactComponent };